import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import SearchBar from '@/common/SearchBar'

interface Props {
  isFetching?: boolean
  children?: React.ReactNode
}

export default function StaffCustomersFilters({
  isFetching = false,
  children,
}: Props) {
  const { t } = useTranslation(['staff'])

  return (
    <View className="mx-8">
      <SearchBar
        label={t('staff:customers.input.label')}
        placeholder={t('staff:customers.input.placeholder')}
        isFetching={isFetching}
      >
        {children}
      </SearchBar>
    </View>
  )
}
